import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/bairro`

    return {
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${url.serialize(queryParms)}`)
        },
    }
}